import { render, staticRenderFns } from "./FacilityLicenseSelector2.vue?vue&type=template&id=5805f27e"
import script from "./FacilityLicenseSelector2.vue?vue&type=script&lang=js"
export * from "./FacilityLicenseSelector2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports